import React from 'react'
import { formatMoney } from '../../../../utils/js/shared_helpers'
import SectionTitle from '../../../../components/section_title/SectionTitle'
import Puckpedia from '../../../../components/puckpedia/Puckpedia'

import './PlayerSalary.scss'

const PlayerSalary = ({ salary }) => {
    if (!salary) return null

    const currentYear = new Date().getFullYear()

    let salaryClauseData = salary.clauses
        ? salary.clauses.filter(clause => clause.year === currentYear)
        : []
    salaryClauseData = salaryClauseData.length !== 0 ? salaryClauseData[0] : {}

    const salaryClause =
        salaryClauseData.status === 'ntc'
            ? 'No Trade'
            : salaryClauseData.status === 'nmc'
            ? 'No Movement'
            : 'N/A'

    const capHit = salary.caphit_final
        ? `$${formatMoney(salary.caphit_final)}`
        : salary.caphit_initial
        ? `$${formatMoney(salary.caphit_initial)}`
        : 'N/A'

    return (
        <div className="PlayerSalary__cont">
            <SectionTitle title="CONTRACT INFO" />
            <div className="player_salary_container">
                <div className="salary_row">
                    <div className="salary_title">SALARY</div>
                    <div className="salary_value">
                        <span>{salary.salary ? `$${formatMoney(salary.salary)}` : 'N/A'}</span>
                        {salary.last_year ? ` Exp. ${salary.last_year}` : ''}
                        {salary.status ? ` (${salary.status})` : ''}
                    </div>
                </div>
                <div className="salary_row">
                    <div className="salary_title">CAP HIT</div>
                    <div className="salary_value">{capHit}</div>
                </div>
                <div className="salary_row">
                    <div className="salary_title">CLAUSE</div>
                    <div className="salary_value">{salaryClause}</div>
                </div>
                <Puckpedia link={salary.deep_link} />
            </div>
        </div>
    )
}

export default PlayerSalary
